const useWebViewBridge = () => {
  function sendMessageToReactNative(message) {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(message);
    } else {
      console.error("ReactNativeWebView not available");
    }
  }

  return {
    sendMessageToReactNative,
  };
};

export default useWebViewBridge;
